import { GET_DRUGS_LAB_TESTS_HXNG_STATUS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    status: {
        drugs?: Drugs;
        labs?: Labs;
    };
}

export interface Drugs {
    [k: string]: Drug;
}

interface Drug {
    hxng_mapped: HXNG_MAPPED;
    hxng_status: HXNG_STATUS;
}

export enum HXNG_MAPPED {
    YES = 'yes',
    NO = 'no',
    UNKNOWN = '',
}

export enum HXNG_STATUS {
    AVAILABLE = 'available',
    NOT_AVAILABLE = 'not available',
    UNKNOWN = 'unknown',
}

interface Labs {
    [k: string]: Lab;
}

interface Lab {
    book: boolean;
}

interface Request {
    drugs?: IdsArray;
    labs?: IdsArray;
}

interface IdsArray {
    ids: string[];
}

export default (request: Request): Promise<Response> =>
    fetchWithRefresh(GET_DRUGS_LAB_TESTS_HXNG_STATUS, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
